import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'
import { Button } from 'components/atoms/button'

interface LeavePageConfirmationModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onConfirm: () => void
	onCancel: () => void
}

export function LeavePageConfirmationModal({ open, setOpen, onConfirm, onCancel }: LeavePageConfirmationModalProps) {
	return (
		<ConfirmationModal title="Are you sure?" open={open} setOpen={setOpen} blur>
			<div>
				<div className="mb-8">You have unsaved changes. Are you sure you want to leave this page?</div>
				<div className="space-y-2">
					<Button
						variant="primary"
						fullWidth
						onClick={() => {
							setOpen(false)
							onConfirm()
						}}
					>
						Yes
					</Button>
					<Button
						variant="secondary"
						fullWidth
						onClick={() => {
							onCancel()
							setOpen(false)
						}}
					>
						Cancel
					</Button>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface LeavePageConfirmationModalManagedProps {
	onConfirm: () => void
	onCancel?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'leave-page-confirmation': LeavePageConfirmationModalManagedProps
	}
}

export function ManagedLeavePageConfirmationModal({
	onClose,
	onConfirm,
	onCancel,
}: LeavePageConfirmationModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<LeavePageConfirmationModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm(); handleClose() }}
			onCancel={() => { onCancel?.(); handleClose() }}
		/>
	)
}
